import { computed } from "vue";
import dayjs from "@/plugins/dayjs";
/**
 * Prevents broken date range
 * e.g until is before from date and vice versa
 *
 * @param form reference to form
 * @param options.startKey key where to access validFrom/startDate in form
 * @param options.endKey key where to access validUntil/endDate in form
 */
export function useDateRangeBorkedPrevention(form, { startKey, endKey }) {
    const startDate = computed({
        get() {
            return form.value[startKey];
        },
        set(v) {
            if (endDate.value) {
                const date = dayjs(v);
                if (date.isAfter(endDate.value)) {
                    endDate.value = v;
                }
            }
            form.value[startKey] = v;
        }
    });
    const endDate = computed({
        get() {
            return form.value[endKey];
        },
        set(v) {
            if (startDate.value) {
                const date = dayjs(v);
                if (date.isBefore(startDate.value)) {
                    startDate.value = v;
                }
            }
            form.value[endKey] = v;
        }
    });
    return {
        startDate,
        endDate
    };
}
